import mitt from 'mitt';

type Events = {
    error: string;
    'notifications:updated': void;
    'news:updated': void;
};

export const eventEmitter = mitt<Events>();
